import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/product/$productId/_layout/")({
  loader: async ({ params, parentMatchPromise }) => {
    if ((await parentMatchPromise).fullPath === "/product/$productId") {
      throw redirect({
        to: "/product/$productId/overview",
        params,
        search: (prev) => ({
          ...prev,
        }),
      })
    }
    return null
  },
})
